/**
 * Helpers for creating Folders instance
 */

import type { IBaseNotary } from "../../BaseNotaryFactory";
import type { OfficeFolder } from "le-coffre-resources/dist/Notary";
import type { QueryPayload } from "../../../../types";
import type { IGetFoldersParams } from "../Folders";
import {
	createGetMethod,
	createGetByUidMethod,
	createGetDemandableDocumentTypesMethod,
	createPostMethod,
	createPutMethod,
	createDeleteMethod,
	createArchiveMethod,
	createUnarchiveMethod,
	createGetDeletedMethod,
	createRestoreFolderMethod,
	createPostLongTermArchiveMethod,
	type DemandableDocumentTypeApiRow,
} from "./foldersMethodsHelpers";

export interface FoldersInstance {
	get(q: IGetFoldersParams): Promise<OfficeFolder[]>;
	getByUid(uid: string, q?: QueryPayload): Promise<OfficeFolder>;
	getDemandableDocumentTypes(uid: string): Promise<{ document_types: DemandableDocumentTypeApiRow[] }>;
	post(officeFolder: Partial<OfficeFolder>): Promise<OfficeFolder>;
	put(uid: string, body: Partial<OfficeFolder>): Promise<OfficeFolder>;
	delete(uid: string): Promise<OfficeFolder>;
	archive(uid: string, archived_description: string): Promise<OfficeFolder>;
	unarchive(uid: string): Promise<OfficeFolder>;
	getDeleted(): Promise<OfficeFolder[]>;
	restoreFolder(uid: string): Promise<OfficeFolder>;
	postLongTermArchive(uid: string): Promise<OfficeFolder>;
}

/**
 * Create Folders instance with all methods
 */
export function createFoldersInstance(baseNotary: IBaseNotary): FoldersInstance {
	const baseUrl = baseNotary.namespaceUrl.concat("/folders");

	return {
		get: createGetMethod(baseNotary, baseUrl),
		getByUid: createGetByUidMethod(baseNotary, baseUrl),
		getDemandableDocumentTypes: createGetDemandableDocumentTypesMethod(baseNotary, baseUrl),
		post: createPostMethod(baseNotary, baseUrl),
		put: createPutMethod(baseNotary, baseUrl),
		delete: createDeleteMethod(baseNotary, baseUrl),
		archive: createArchiveMethod(baseNotary, baseUrl),
		unarchive: createUnarchiveMethod(baseNotary, baseUrl),
		getDeleted: createGetDeletedMethod(baseNotary, baseUrl),
		restoreFolder: createRestoreFolderMethod(baseNotary, baseUrl),
		postLongTermArchive: createPostLongTermArchiveMethod(baseNotary, baseUrl),
	};
}
